import { BindAll } from 'lodash-decorators'
import type { SearchForm } from './types.d'
import type { Dictionary } from 'vue-router/types/router'
import { myCourseMenuFilter } from '@xt/client/dataSource/my/index'

export type RouteQuery = Dictionary<string | (string | null)[]>

@BindAll()
export class MyCourseController {
  getSeachListByFieldName(fieldName: keyof SearchForm, routerQuery: RouteQuery) {
    switch (fieldName) {
      case 'contentType':
        return myCourseMenuFilter
      case 'courseType':
        const parseField = this.getFieldParser(routerQuery)
        return myCourseMenuFilter.find(item => item.value === parseField('contentType'))?.filters || []
      default:
        return []
    }
  }

  getFieldParser(routerQuery: Dictionary<string | (string | null)[]>) {
    return (fieldName: keyof SearchForm, defultValue: string = '') => {
      const fieldValue = routerQuery[fieldName]

      if (typeof fieldValue !== 'string') return ''

      return this.getSeachListByFieldName(fieldName, routerQuery).find(i => i.value.toString() === fieldValue)?.value || defultValue
    }
  }

  // 获取路由参数
  public parserQuery(routerQuery: Dictionary<string | (string | null)[]>): SearchForm {
    const parseField = this.getFieldParser(routerQuery)

    return {
      contentType: parseField('contentType'),
      courseType: parseField('courseType')
    }
  }

  // 获取查询query值
  public toSearchQuery(form: SearchForm): Record<keyof SearchForm, string> {
    const obj = {} as Record<keyof SearchForm, string>

    Object.keys(form).forEach(key => {
      if (form[key].toString() !== '') {
        obj[key] = form[key].toString()
      }
    })

    return obj
  }
}
